import { staticPageMetadata } from '../../lib/i18n/staticPageMetadata';
import React from 'react';
import { ScrollView, StyleSheet, View } from 'react-native';
import { Stack } from 'expo-router';

import AgentsPageBody from '../../components/agents/AgentsPageBody';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import MetaTags from '../../components/MetaTags';
import { useFontLoading } from '../../lib/FontContext';

export default function AgentsScreen() {
    const { fontsLoaded } = useFontLoading();

    return (
        <>
            <MetaTags
                surfaceId="agents"
            />
            <Stack.Screen options={{ headerShown: false }} />
            <View style={styles.page}>
                <Header />
                <ScrollView style={styles.scrollView} showsVerticalScrollIndicator={false}>
                    <AgentsPageBody fontsLoaded={fontsLoaded} />
                    <Footer />
                </ScrollView>
            </View>
        </>
    );
}

const styles = StyleSheet.create({
    page: {
        backgroundColor: '#f7f4ec',
        flex: 1,
    },
    scrollView: {
        flex: 1,
    },
});

export function generateMetadata() {
    return staticPageMetadata({ surfaceId: 'agents' });
}
